import { mapState, mapActions, mapMutations } from "vuex";
import { _message } from "@/helpers/_message"
export default {
    props: {
        stt: {
            type: Number,
            default: 0
        },
        length: {
            type: Number,
            default: 1
        },
    },
    data() {
        return {
            isdeleted: false,
            ksTruongId: null,
            khaosat: {}
        };
    },
    computed: {
        ...mapState({
            truongdaihoc: (state) => state.khaosat.truongdaihoc,
            khaosats: (state) => state.khaosat.khaosats
        }),
    },
    methods: {
        ...mapActions({

        }),
        ...mapMutations({
            updateKhaoSatTruongId: "khaosat/updateKhaoSatTruongId",
            deleteKhaoSat: "khaosat/deleteKhaoSat",
        }),
        async updateKhaoSat() {
            let ks = await this.khaosats.findIndex(
                (item) => item.ksTruongId === this.khaosat.ksTruongId
            );
            if (ks.thuTu != this.stt && ks >= 0) {
                _message.trungKhaoSat();
                this.khaosat = {};
                return;
            }
            this.updateKhaoSatTruongId({ khaosat: this.khaosat, stt: this.stt });
        },
    },
    created() {
        this.khaosat = { ...this.khaosats[this.stt] };
    },
}